// /UI/Dropzone/hooks/useAuthentication.js
import { useState, useEffect } from 'react';
import { signIn } from '../../../../controllers/basicAuthlbda';
/**
 * Hook to handle authentication for file uploads
 * @param {Function} addNotification - Function to add notifications
 * @returns {Object} Authentication state and token
 */
export const useAuthentication = addNotification => {
  const [token, setToken] = useState(null);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const authenticate = async () => {
      if (!token && !isAuthenticating) {
        setIsAuthenticating(true);
        setAuthError(null);

        try {
          const authToken = await signIn();
          setToken(authToken);
        } catch (error) {
          console.error('Authentication error:', error);
          setAuthError(error.message || 'Unable to authenticate');

          if (addNotification) {
            addNotification('error', 'Unable to authenticate. Please try again.');
          }
        } finally {
          setIsAuthenticating(false);
        }
      }
    };

    authenticate();
  }, [token, addNotification, isAuthenticating]);

  return { token, isAuthenticating, authError };
};
